var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotelS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 22 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hotel-S ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KLM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotel-S-",
    fill: "#B3D6E5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3698,11 L22,11 L22,3.3 L20.3698,3.3 L20.3698,11 Z M1.6302,7.7 L1.6302,11 L0,11 L0,0 L1.6302,0 L1.6302,4.8906 L7.1489,4.8906 L7.1489,7.7 L1.6302,7.7 Z M19.239,3.3 C19.239,2.8589 19.063,2.4354 18.7517,2.1241 C18.4393,1.8117 18.0169,1.6368 17.5758,1.6368 C14.8764,1.6368 8.2478,1.6368 8.2478,1.6368 L8.2478,7.7 L19.239,7.7 L19.239,3.3 Z M2.7489,1.1407 L2.7489,3.9072 L7.1489,3.9072 C7.1489,3.9072 7.5438,0.7051 2.7489,1.1407 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelS);
export default __webpack_public_path__ + "static/media/hotel-S.44a81659b245928bc4f205e75c40435d.svg";
export { ForwardRef as ReactComponent };